var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 14.9334L15.0667 8.2667C15.6 7.73337 16.4 7.73337 16.9333 8.2667C17.4667 8.80003 17.4667 9.60003 16.9333 10.1334L12.5333 14.5334H22.6667C23.4667 14.5334 24 15.0667 24 15.8667C24 16.6667 23.4667 17.2 22.6667 17.2H12.5333L16.9333 21.6C17.4667 22.1334 17.4667 22.9334 16.9333 23.4667C16.4 24 15.6 24 15.0667 23.4667L8.4 16.8C7.86667 16.4 7.86667 15.4667 8.4 14.9334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.ed15fddc97ec9a6a9c7904403829e4ee.svg";
export { ForwardRef as ReactComponent };